import script from "./CodeBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CodeBox.vue?vue&type=script&setup=true&lang=js"

import "./CodeBox.vue?vue&type=style&index=0&id=50d7480a&lang=css"

const __exports__ = script;

export default __exports__